import apiCall, { scheduleTokenRefresh } from 'auth/ApiCallInstance'

const AuthService = {}

AuthService.login = async function (data) {
	const response = await apiCall.post('/auth/login', data);
	
	// Schedule proactive token refresh after successful login
	if (response.data?.token) {
		scheduleTokenRefresh(response.data.token);
	}
	
	return response.data;
}

AuthService.register = function (data) {
	return apiCall.post('/auth/register', data).then(res => res.data);
}

AuthService.logout = function (data) {
	return apiCall.post('/auth/logout', data).then(res => res.data);
}

AuthService.refreshToken = function (data) {
	return apiCall.post('/auth/refresh-token', data).then(res => res.data);
}

AuthService.me = function () {
	return apiCall.get('/auth/me').then(res => res.data);
}

AuthService.changePassword = function (data) {
	return apiCall.post('/auth/change-password', data).then(res => res.data);
}

AuthService.getSessions = function () {
	return apiCall.get('/auth/sessions').then(res => res.data);
}

AuthService.revokeSession = function (sessionId) {
	return apiCall.delete(`/auth/sessions/${sessionId}`).then(res => res.data);
}

export default AuthService;
